import React from 'react';
import { connect } from 'react-redux';
import { resizeColumn, resizeColumnFinished } from '../actions/row-actions';
import find from 'lodash.find';
import findIndex from 'lodash.findindex';

import styles from '../../../../stylesheet/css/header-builder/column-resizer.css';
import rowStyles from '../../../../stylesheet/css/header-builder/row.css';

function mapStateToProps(state, ownProps) {
  const { device, rowId, columnId } = ownProps,
        { model: { [device]: deviceModel } } = state,
        { rows } = deviceModel.present,
        row = find(rows, r => r.id === rowId);

  if (!row) {
    return {};
  }

  const { columns } = row,
        columnIndex = findIndex(columns, c => c.id === columnId),
        { width: columnWidth } = columns[columnIndex],
        widthSum = columns.slice(0, columnIndex + 1).reduce((s, c) => s + c.width, 0);

  return {
    columnWidth,
    widthSum
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onResize(data) {
      dispatch(resizeColumn(data));
    },

    onResizeFinished(data) {
      dispatch(resizeColumnFinished(data));
    }
  };
}

const ColumnResizer = React.createClass({
  preventRowClick(e) {
    e.stopPropagation();
  },

  onDragStart(e) {
    e.preventDefault();
    e.stopPropagation();

    this.initialClientX = e.clientX;
    this.initialColumnWidth = this.props.columnWidth;

    /**
     * Prevent from firing click on Row element when
     * dragging ends (Firefox and IE10).
     */
    this.rowNode = e.target.parentNode;
    this.rowNode.classList.add(rowStyles.background);
    this.rowNode.addEventListener('click', this.preventRowClick, false);

    this.lastCursor = document.body.style.cursor;

    document.addEventListener('mousemove', this.onMouseMove, false);
    document.addEventListener('mouseup', this.onMouseUp, false);
  },

  onMouseMove(e) {
    const rowWidth = this.el.parentNode.offsetWidth,
          deltaX = e.clientX - this.initialClientX,
          columnsMoved = Math.round(deltaX / rowWidth * 12),
          { device, rowId, columnId, onResize } = this.props;

    document.body.style.cursor = 'col-resize';

    if (this.lastColumnsMoved !== columnsMoved) {
      if (this.lastColumnsMoved !== undefined) {
        onResize({ device, rowId, columnId, size: this.initialColumnWidth + columnsMoved });
      }

      this.lastColumnsMoved = columnsMoved;
    }
  },

  onMouseUp(e) {
    this.rowNode.classList.remove(rowStyles.background);
    const { device, rowId, columnId, onResizeFinished } = this.props;
    document.body.style.cursor = this.lastCursor;

    setTimeout(() => {
      this.rowNode.removeEventListener('click', this.preventRowClick, false);
      this.rowNode = null;
    }, 0);

    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);

    if (this.lastColumnsMoved !== 0) {
      onResizeFinished({ device, rowId, columnId, size: this.initialColumnWidth + this.lastColumnsMoved });
      this.lastColumnsMoved = 0;
    }
  },

  render() {
    const { width, widthSum } = this.props,
          left = `calc((100% - ${width}px) * ${widthSum} / 12)`;

    return (
      <div className={styles.resizer}
        draggable="true"
        style={{ width, left }}
        ref={el => this.el = el}
        onDragStart={this.onDragStart} />
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ColumnResizer);



// WEBPACK FOOTER //
// ./app/header-builder/components/ColumnResizer.js